// extracted by mini-css-extract-plugin
export default {"select":"select__5EVCF","emojiSelect":"emojiSelect__DUXS4","iconLabel":"iconLabel__SBvZG","fieldLabel":"fieldLabel__OWfJ_","fieldsHeading":"fieldsHeading__EaiCG"};